import { render, staticRenderFns } from "./NominateTalentToClientPricingTable.vue?vue&type=template&id=a72e14f2&scoped=true"
import script from "./NominateTalentToClientPricingTable.vue?vue&type=script&lang=js"
export * from "./NominateTalentToClientPricingTable.vue?vue&type=script&lang=js"
import style0 from "./NominateTalentToClientPricingTable.vue?vue&type=style&index=0&id=a72e14f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72e14f2",
  null
  
)

export default component.exports